import axios from "axios";
import store from "services/structure/store";

const apiLogin = axios.create({
  baseURL: process.env.REACT_APP_REST_LOGIN_URL
});

apiLogin.interceptors.request.use(async config => {
  const tenant = store.getState()?.layoutState?.tenant;
  if (tenant) {
    config.headers.tenant = tenant;
  }
  return config;
});

export default apiLogin;